import { createContext, useContext } from 'react';
import { PrinterModelType } from '../api/types/vendor/printers.type';

export interface BluetoothPrinterInfo {
  model: PrinterModelType;
  identifier: string;
  deviceName: string;
}

type BluetoothPrinterContextType = {
  printers: BluetoothPrinterInfo[];
  initiateDiscovery: () => void;
};

const BluetoothPrinterContext = createContext<BluetoothPrinterContextType>({
  printers: [],
  initiateDiscovery: () => {},
});

function useBluetoothPrinter(): BluetoothPrinterContextType {
  const context = useContext(BluetoothPrinterContext);

  if (!context) {
    throw new Error(
      'useBluetoothPrinter must be used within an BluetoothPrinterProvider',
    );
  }

  return context;
}

export { BluetoothPrinterContext, useBluetoothPrinter };
